import React, { memo } from 'react';

const IconVat = ({ color = "black", ...props }) => (
  <svg {...props} width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M3 10L12 4L21 10V20C21 20.2652 20.8946 20.5196 20.7071 20.7071C20.5196 20.8946 20.2652 21 20 21H4C3.73478 21 3.48043 20.8946 3.29289 20.7071C3.10536 20.5196 3 20.2652 3 20V10Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M9 21V12H15V21" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default memo(IconVat);
